import type { BacktestResultQuarantine } from '@einhaus/project314-types';
import Alert from '@/components/UI/Alert';

export default function BacktestQuarantineNotice({ quarantine }: { quarantine: BacktestResultQuarantine | null }) {
    if (!quarantine) return null;
    const reason =
        quarantine.reasonCode === 'futuresUtcMidnightV1'
            ? 'A UTC-midnight defect closed futures positions too early.'
            : quarantine.reasonCode === 'futuresResearchSemanticsV2'
              ? 'This run predates corrected no-trade minutes, contract-roll closes and price-return percentages. Stored metrics retain their original meaning.'
              : quarantine.reasonCode;
    return (
        <Alert variant="danger">
            <strong>Quarantined result — historical evidence only.</strong> {reason} The original trades and accounting are preserved below.
            This result is excluded from comparisons, best-result selection and reuse. Run a new backtest after the correction to obtain
            valid evidence.
        </Alert>
    );
}
